import { Checkbox as CheckboxSchema } from '@/schemas/sceneDataSchema';
import { encodeFieldKey } from '@/schemas/validation/ValidationSchemaGenerator';
import { Checkbox, FormControl } from '@mui/material';
import { Controller, UseFormReturn } from 'react-hook-form';
import useAnalytics from '@/hooks/use-analytics';

export default function CheckboxFormElement({ form, component }: { form: UseFormReturn; component: CheckboxSchema }) {
  const { trackEvent } = useAnalytics();

  return (
    <FormControl sx={{ display: 'contents' }}>
      <Controller
        name={encodeFieldKey(component)}
        control={form.control}
        render={({ field: { onChange, value, ...field } }) => (
          <Checkbox
            {...field}
            onChange={(...args) => {
              trackEvent(`${component.attribute}_CHECKED`);
              onChange(...args);
            }}
            value={!!value}
            checked={!!value}
          />
        )}
      />
    </FormControl>
  );
}
